export default {
  // addItem: {
  //   position: 'absolute',
  //   right: 200,
  //   top: 35,
  //   zIndex: 1100,
  // },
  chip: {
    margin: 5,
  },
  noDataRow: {
    textAlign: 'center',
    color: 'lightgrey',
    fontSize: 24,
  },
  noData: {
    fontSize: 250,
    color: 'lightgrey',
  },
}


// WEBPACK FOOTER //
// ./src/components/Admin/TaskProfiles/TaskProfilesGrid/styles.js